import React, { useContext, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";
import './css/menu.css';
import './css/onprinttoggle.css';
import Image from 'react-bootstrap/Image';
import Logo from '../../margretlogo.png';
const Menu = () => {
    const location = useLocation();

    return (
        <div className="usr_menu print_hide">
            <br />
            <center><Image src={Logo} style={{ width: 80, height: 90 }} /></center>
            <center><h6>خەرجی و هاوکاریەکانی کەریمی عەلەکە</h6></center>
            <ul>
                <Link to="/manager/"><li className={location.pathname == '/manager/' ? 'aactive' : null}>داهات</li></Link>
                <Link to="/manager/expense"><li className={location.pathname == '/manager/expense' ? 'aactive' : null}>خەرجی</li></Link>
                <Link to="/manager/income_report"><li className={location.pathname == '/manager/income_report' ? 'aactive' : null}>ڕاپۆرتی داهات</li></Link>
                <Link to="/manager/expense_report"><li className={location.pathname == '/manager/expense_report' ? 'aactive' : null}>ڕاپۆرتی خەرجی</li></Link>
                <Link to="/manager/report"><li className={location.pathname == '/manager/report' ? 'aactive' : null}>ژمێریاری گشتی</li></Link>
            </ul>
        </div>
    )
}

export default Menu